import script from "./TotalPage.vue?vue&type=script&setup=true&lang=js"
export * from "./TotalPage.vue?vue&type=script&setup=true&lang=js"

import "./TotalPage.vue?vue&type=style&index=0&id=f596dc3a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f596dc3a"]])

export default __exports__